import React from 'react';
import { CgArrowLongRight } from 'react-icons/cg';
import { Link } from 'react-router-dom';

const OurSingleExpertise = ({ icon, title, content }) => {
   return (
      <>
         <div className="features__item fix mb-30">
            <div className="features__content">
               <div className="features__icon">
                  <i> {icon} </i>
               </div>
               <h3>{title}</h3>
               <p>{content}</p>
               <div className="features__btn">
                  <Link to="/" className="link-btn" aria-label={`Learn more about ${title}`}>
                     <i > <CgArrowLongRight /> </i>
                  </Link>
               </div>
            </div>
         </div>
      </>
   );
};

export default OurSingleExpertise;